import { Button, Stack } from '@mui/material'

import useT from '@/i18n/useT'

import {
  StoreFormContent,
  StoreFormProps,
  useStoreForm,
} from './AddEditStoreShared'

const AddEditStoreForm = (props: StoreFormProps & { saving: boolean }) => {
  const { onCancel, mode, otherButtons, saving } = props
  const { t } = useT()
  const { formik, needsToEdit, onPlaceSelected } = useStoreForm(props)

  return (
    <form noValidate onSubmit={formik.handleSubmit}>
      <Stack spacing={4}>
        <StoreFormContent
          formik={formik}
          needsToEdit={needsToEdit}
          mode={mode}
          onPlaceSelected={onPlaceSelected}
        />
        <Stack
          direction="row"
          spacing={2}
          flex={1}
          width="100%"
          justifyContent={'flex-end'}
        >
          {onCancel && (
            <Button
              onClick={onCancel}
              variant="outlined"
              color="primary"
              disabled={formik.isSubmitting}
            >
              {t('common.cancel')}
            </Button>
          )}
          <Button
            type="submit"
            variant="contained"
            color="primary"
            loading={saving || formik.isSubmitting}
            loadingPosition="end"
            disabled={saving || needsToEdit}
          >
            {props.mode === 'add'
              ? t('addEditStore.form.addStore')
              : t('common.saveChanges')}
          </Button>
          {otherButtons?.map((button, index) => (
            <Button key={index} {...button} />
          ))}
        </Stack>
      </Stack>
    </form>
  )
}

export default AddEditStoreForm
